/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultNiveau } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_multi_009: Question = {
  id: 'multi-009-non-utilisation-pesticides',
  oldId: '70',
  title: 'Non-utilisation des pesticides dans les activités de l’organisation municipale',
  number: '7.1',
  description: [''],
  type: QuestionType.ACTIVITY,
  frequency: 1,
  idEM: 8,
  slots: [
    {
      type: SlotTypes.NIVEAU,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: false,
      scoringFct: (data: string[]) => parseFloat(data[0]),
      score: '0',
      maxScore: 1,
      help: defaultNiveau,
      unit: SlotUnit.OPTIONS,
    },
  ],
};

export const question_multi_009_v2: Question = question_multi_009;
export const question_multi_009_v3: Question = question_multi_009;
